<template>
  <div id="farm">
    <div class="cc" v-if="step == 1">
      <div class="xnz">
        <div class="items">
          <div
            class="item"
            v-for="(v, k) in farms"
            :key="k"
            @click="doFarmChoose(v)"
          >
            <img :src="v.url" alt="" />
          </div>
        </div>
      </div>
      <div class="qd">
        <img
          src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560961658557.png"
          alt=""
        />
      </div>
    </div>

    <div class="pt" v-if="step == 2">
      <div class="pt-modal">
        <div class="items">
          <div class="item" v-for="v in putaos" :key="v.id">
            <img :src="v.url" alt="" @click="doShowInfo(v)" />
            <!-- <div class="show-info">
              <img
                src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560959525758.png"
                alt=""
                @click.stop="doShowInfo(v)"
              />
            </div> -->
          </div>
        </div>
      </div>

      <div class="info-modal" v-if="showInfo">
        <div class="content">
          <div class="info">{{ putao.info }}</div>
          <div class="close-btn" @click="showInfo = false">
            <img
              src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560964823279.png"
              alt=""
            />
          </div>
        </div>
        <div class="xuan-ding">
          <img
            src="https://i.tmuyun.com/webpic/W0202206/W020220609/W020220609362983822289.png"
            alt=""
            @click="doChoosePutao"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { allPutao, addLingqu, oneLingqu } from "@/api/tmnc";
import { Dialog } from "vant";
import { redirect } from "../../../../utils/common";

export default {
  name: "TmncFarm",
  data() {
    return {
      step: 0,
      putaos: [],
      farm: {},
      farms: [
        {
          name: "老五农庄",
          url: "https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560964003433.png",
        },
        {
          name: "红土地专业合作社",
          url: "https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560962825836.png",
        },
        {
          name: "紫满园家庭农场",
          url: "https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560958993716.png",
        },
        {
          name: "滨新水果种植园",
          url: "https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560966413418.png",
        },
        {
          name: "滨海葡萄专业合作社",
          url: "https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560965376600.png",
        },
      ],
      showInfo: false,
      doing: false,
    };
  },
  mounted() {
    oneLingqu().then((res) => {
      if (res.data !== false) {
        this.$router.replace("/creative/tmnc/plant");
      } else {
        allPutao().then((res) => {
          if (res.code == 1) {
            this.step = 1;
            this.putaos = res.data;
          }
        });
      }
    });
  },
  methods: {
    doFarmChoose(farm) {
      // console.log(farm);
      this.farm = farm;
      this.step = 2;
    },
    doChoosePutao() {
      // console.log(putao);
      const farm = this.farm.name;
      Dialog.confirm({
        message: "确认选择种植" + this.putao.name + "吗？该选择不可更改。",
      })
        .then((res) => {
          if (this.doing) return false;
          addLingqu({ farm: farm, putao_id: this.putao.id }).then((re) => {
            if (re.code == 1) {
              this.$router.replace("/creative/tmnc/plant");
            }
          });
        })
        .catch((err) => {
          this.showInfo = false;
          console.log(err);
        });
    },
    doShowInfo(putao) {
      this.putao = putao;
      this.showInfo = true;
    },
  },
};
</script>

<style lang="less" scoped>
#farm {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url(https://i.tmuyun.com/webpic/W0202205/W020220530/W020220530566869774115.jpg);
  background-size: 100%;
  background-color: #a17651;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  img {
    width: 100%;
  }
  .cc {
    width: 70vw;
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .xnz {
      height: 60vh;
      background-image: url(https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560965636426.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .items {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        height: 70%;
        margin: 90px auto auto auto;
        width: 80%;
      }
    }
    .qd {
      display: none;
      width: 25vw;
      margin: auto;
    }
  }
  .pt {
    position: relative;
    width: 70vw;
    height: 35vh;
    background-image: url(https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560957904074.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    // border: 1px solid red;
    .items {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;
      width: 90%;
      margin: 40px auto auto auto;
      .item {
        position: relative;
        flex: 0 0 30%;
        margin-top: 10px;
        .show-info {
          position: absolute;
          width: 30%;
          right: -5px;
          top: -5px;
        }
      }
    }
    .info-modal {
      position: absolute;
      width: 70%;
      height: 40%;
      background-image: url(https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560957244075.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .content {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .info {
          text-indent: 2em;
          text-align: justify;
          padding: 0 15px;
        }
        .close-btn {
          position: absolute;
          right: -5px;
          top: -5px;
          width: 25px;
        }
      }
      .xuan-ding {
        margin: 10px auto;
        width: 50%;
      }
    }
  }
}
</style>